module.exports = __webpack_public_path__ + "static/media/increaseicon.5c0dfd96.svg";